import {ReactNode} from 'react'
import './Typography.scss'

export const PageTitle = ({title, children, id, className}: { title: string, children?: ReactNode, id?: string, className?: string }) => {
    return <h2 className={'page-title ' + (className ? className : '')} title={title} id={id ? id : ''}>{children ? children : title}</h2>
}